import React, { useState } from 'react'
import LoginLayout from '../../layouts/Login'
import ImageLogin from '../../assets/ImageLogin.png'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import api from '../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../utils/errorApi'

import styles from './styles.module.css'
import { useLoading } from '../../hooks/LoadingContext'
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState<string>('')
  const { isLoading, setIsLoading } = useLoading()

  const navigate = useNavigate()

  const handleSubmit = async (event: any) => {
    event.preventDefault()

    setIsLoading(true)
    try {
      await api.post(`/users/password/recovery/`, { email: email })
      toast.info('Email de recuperação enviado!', { autoClose: 3000 })
      setIsLoading(false)
      navigate('/login')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao solicitar recuperação de senha! Verifique seus dados.'))
      setIsLoading(false)
    }
  }

  const isValidModel = () => {
    return email;
  }
  return (
    <LoginLayout backgroundColor="#fff" imageSrc={ImageLogin}>
      <LoadingSpinner text="Salvando informações. Aguarde..." />
      <h1
        style={{
          fontWeight: '500',
          fontSize: 26,
          color: '#667080',
          marginTop: 15,
        }}
      >
        Esqueceu sua senha?
      </h1>
      <Form>
        <Row style={{ marginTop: 15, textAlign: 'left' }}>
          <Col>
            <Form.Label className={styles.label}>Email</Form.Label>
            <Form.Control
              className={styles.input}
              placeholder="Digite aqui seu email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </Col>
        </Row>
        <Col style={{ textAlign: 'right', marginTop: 10 }}>
          <span>
            <Link to="/login" style={{ color: '#053C5E', fontWeight: '500' }}>
              Voltar para login
            </Link>{' '}
          </span>
        </Col>
        <Col className="d-grid" style={{ marginTop: 15 }}>
          <Button
            className={styles.sendMailBtn}
            variant="primary"
            type="submit"
            disabled={isLoading || !isValidModel()}
            onClick={(event) => handleSubmit(event)}
          >
            {isLoading ? (
              <Spinner
                animation="border"
                size="sm"
                style={{
                  color: '#fff',
                  marginRight: 10,
                }}
              />
            ) : (
              'Enviar email de recuperação'
            )}
          </Button>
        </Col>
      </Form>
    </LoginLayout>
  )
}

export default ForgotPassword
